import React from 'react';
import PropTypes from 'prop-types';
import { AccentLabel, VerticalFlex } from 'smartsuite-ui';
import useLink from '../../../../shared/hooks/linkHooks';

function renderValue(linkConfig, openLinksInNewTab, uri, value) {
    if (!linkConfig) {
        return value;
    }
    return (
        <a
            href={uri}
            rel="noreferrer"
            target={openLinksInNewTab ? '_blank' : ''}
        >
            {value}
        </a>
    );
}

export default function GaugeTicketValue(props) {
    const linkUri = useLink(props.linkConfig, props.metricRequest);

    return (
        <div style={{ width: props.widthStyle }}>
            <VerticalFlex>
                <AccentLabel>{props.label}</AccentLabel>
                <span style={props.valueStyles} title={props.title}>
                    {renderValue(
                        props.linkConfig,
                        props.openLinksInNewTab,
                        linkUri,
                        props.value
                    )}
                </span>
            </VerticalFlex>
        </div>
    );
}

GaugeTicketValue.propTypes = {
    label: PropTypes.string.isRequired,
    linkConfig: PropTypes.instanceOf(Object),
    metricRequest: PropTypes.instanceOf(Object).isRequired,
    openLinksInNewTab: PropTypes.bool.isRequired,
    title: PropTypes.string,
    value: PropTypes.string.isRequired,
    valueStyles: PropTypes.instanceOf(Object),
    widthStyle: PropTypes.string,
};

GaugeTicketValue.defaultProps = {
    widthStyle: 'auto',
};
